// HandRow.jsx — bir oyuncunun elindeki taşlar (koma-dai).
import React from 'react';
import { PIECE_NAMES } from '../lib/ShogiEngine';
import { useLang } from '../i18n';

const ORDER = ['R', 'B', 'G', 'S', 'N', 'L', 'P'];

export default function HandRow({ label, hand = {}, active = false, dropType, onPick }) {
  const { t } = useLang();
  const entries = ORDER.filter((k) => hand[k] > 0);
  return (
    <div className="hand-row">
      <span className="hand-label">{label}</span>
      {entries.length === 0 ? (
        <span className="small text-muted">({t('common.noHand')})</span>
      ) : (
        entries.map((type) => (
          <button
            key={type}
            type="button"
            className={`hand-piece jp ${active && dropType === type ? 'active' : ''}`}
            disabled={!active}
            onClick={() => onPick?.(type)}
            aria-label={`${PIECE_NAMES[type]} × ${hand[type]}`}
          >
            {PIECE_NAMES[type]}
            {hand[type] > 1 && <small>{hand[type]}</small>}
          </button>
        ))
      )}
    </div>
  );
}
